import callApi from "Common/utils/apiCaller";
import React, { useEffect, useState } from "react";
import { toast } from "react-toastify";
import HtmlCode from "../HtmlCode/HtmlCode";
import Button from "../ButtonComponent/Button";
import ReactSelect from "../ReactSelect/ReactSelect";
import { showNotification } from "Common/utils/Notification";
import ImageData from "../customImage/ImageSegment";
import ImageView from "../ImageView/ImageView";
import Drawer from "../Drawer";
import { X } from "lucide-react";
import NewHtmlCode from "../HtmlCode/NewHtmlCode";
import ToggleSwitch from "../ToggleSwitch/ToggleSwitch";
import CustomInput from "../InputFields/CustomInput";

const CodeSegments = ({
  pageId,
  data,
  handleDelete,
  loader,
  setLoader,
  pageType,
  segmentId,
  isEditable,
  versionData,
  segmentType,
  toggleVisiblity,
}) => {
  const [headerText, setHeaderText] = useState(data?.html_code);
  const [isLoading, setIsLoading] = useState<any>(false);
  const [saticStyle, setStaticStyle] = useState<any>({
    label: data?.custom_code,
    value: data?.custom_code,
  });
  const [styleType, setStyleType] = useState(data?.custom_code);
  const [custom, setCustom] = useState<any>("");
  const [headerCode, setHeaderCode] = useState<any>({
    label: data?.header_text,
    value: data?.header_text,
  });
  const [headerOption, setHeaderOption] = useState<any>();
  const [errors, setErrors] = useState({
    headerText: "",
  });
  const [imageData, setImageData] = useState<any>("");
  const [showImage, setShowImage] = useState<any>(false);
  const toggleImage = () => setShowImage(!showImage);
  const [imageUrl, setImageUrl] = useState(
    data?.background_image ? data?.background_image : ""
  );
  const [imageId, setImageId] = useState("");
  const [mobileBackground, setMobileBackground] = useState<any>(
    data?.mobile_background_image
  );
  const [mobileBackgroundId, setMobileBackgroundId] = useState<any>(
    data?.mobile_background_image_id
  );
  const [indexBack, setIndexBack] = useState("");

  useEffect(() => {
    if (imageData && imageData?.media_url) {
      if (imageData?.media_type === "image") {
        if (indexBack === undefined) {
          setImageUrl(imageData.media_url);
          setImageId(imageData._id);
          setErrors((prev) => ({ ...prev, ["background_image"]: "" }));
        } else if (indexBack === "background") {
          setMobileBackground(imageData.media_url);
          setMobileBackgroundId(imageData._id);
          setErrors((prev) => ({ ...prev, ["mobile_background_image"]: "" }));
        }
      } else {
        showNotification("Media type should be image", "error");
      }
    }
  }, [imageData, indexBack]);

  useEffect(() => {
    setErrors((prev) => ({ ...prev, ["headerText"]: "" }));
  }, [headerText]);

  useEffect(() => {
    async function fetchData() {
      try {
        const res = await callApi(
          `v1/content/code/${"custom-codes"}`,
          "get",
          {}
        );
        if (res.status === "Success") {
          setCustom([
            { label: "Select", value: "Select..." },
            ...res.data.content.params,
          ]);
        }
      } catch (e) {
        showNotification("Error occured", "error");
      }
    }
    fetchData();
  }, []);

  useEffect(() => {
    async function fetchData() {
      try {
        const res = await callApi(`v1/category/list`, "post", {});
        if (res.status === "Success") {
          setHeaderOption([
            { label: "Select", value: "Select..." },
            ...res.data.categoryList.map((item) => ({
              label: item?.name,
              value: item?.slug,
            })),
          ]);
        }
      } catch (e) {
        showNotification("Error occured", "error");
      }
    }
    fetchData();
  }, []);

  const handleStyleData = (keyName, keyValue) => {
    if (keyValue.value === "Select...") {
      setStyleType("");
    } else {
      setStyleType(keyValue.value);
    }
    setStaticStyle(keyValue);
  };

  const handleHeaderChange = (keyName, keyValue) => {
    if (keyValue.value === "Select...") {
      setHeaderCode({});
    } else {
      setHeaderCode(keyValue);
    }
  };

  const handleSave = async (pageId, id) => {
    const payload = {
      segment_type: "code_segments",
      html_code: headerText,
      custom_code: styleType,
      header_text: headerCode?.value,

      background_image: (imageUrl === null || imageUrl == undefined) ? "" : imageUrl,
      background_image_id: (imageUrl === null || imageUrl == undefined) ? "" : imageId,
      mobile_background_image: (mobileBackground === null || mobileBackground == undefined) ? "" : mobileBackground,
      mobile_background_image_id: (mobileBackground === null || mobileBackground == undefined) ? "" : mobileBackgroundId,
    };

    try {
      setIsLoading(true);
      const response = await callApi(
        `v1/${pageType}/${pageId}/segment/${id}/update-info`,
        "post",
        payload
      );
      setIsLoading(false);
      if (response && response?.status === "Success") {
        setLoader(!loader);
        showNotification("Code added successfully!", "success");
      }
    } catch (e) {
      showNotification(
        "An error occurred while adding the banner. Please try again.",
        "error"
      );
      setIsLoading(false);
    }
  };

  return (
    <>
      <div className="bg-white border border-black-600 rounded-[5px] px-8 py-4">
        <ToggleSwitch
          selectValue={data?.is_visible}
          versionValue={versionData?.is_visible}
          toggle={() =>
            toggleVisiblity(pageId, segmentId, segmentType, !data?.is_visible)
          }
          label="Is Segment Visible?"
          required={true}
        />
        <div className="mb-4 xl:col-span-12">
          <NewHtmlCode
            content={headerText}
            setContent={setHeaderText}
            label={"Code Text"}
            isVersioned={versionData ? true : false}
            versionedValue={versionData?.html_code}
          />

          {/* {errors.headerText && (
            <p className="text-red-500">{errors.headerText}</p>
          )} */}
        </div>
        <div>
          <div className="flex my-4">
            {imageUrl ? (
              <div className="flex items-center">
                <ImageData
                  imageLink={imageUrl}
                  setImageData={setImageData}
                  setImageLink={setImageUrl}
                />
                <div className="h-3 ml-3">
                  <button
                    onClick={() => {
                      toggleImage();
                      setIndexBack(undefined);
                      setImageData(undefined);
                    }}
                    className="text-white btn bg-custom-500 border-custom-500 hover:text-white hover:bg-custom-600 hover:border-custom-600 focus:text-white focus:bg-custom-600 focus:border-custom-600 focus:ring focus:ring-custom-100 active:text-white active:bg-custom-600 active:border-custom-600 active:ring active:ring-custom-100 dark:ring-custom-400/20"
                  >
                    Change
                  </button>
                </div>
              </div>
            ) : (
              <button
                onClick={() => {
                  toggleImage();
                  setIndexBack(undefined);
                  setImageData(undefined);
                }}
                className="text-white btn bg-custom-500 border-custom-500 hover:text-white hover:bg-custom-600 hover:border-custom-600 focus:text-white focus:bg-custom-600 focus:border-custom-600 focus:ring focus:ring-custom-100 active:text-white active:bg-custom-600 active:border-custom-600 active:ring active:ring-custom-100 dark:ring-custom-400/20"
              >
                Add BackgroundImage
              </button>
            )}
          </div>
          {/* {errors.image_url && (
            <p className="text-sm text-red-500">{errors.image_url}</p>
          )} */}
        </div>
        <div>
          <div className="flex my-4">
            {mobileBackground ? (
              <div className="flex items-center">
                <ImageData
                  imageLink={mobileBackground}
                  setImageData={setImageData}
                  setImageLink={setMobileBackground}
                />
                <div className="h-3 ml-3">
                  <button
                    onClick={() => {
                      toggleImage();
                      setIndexBack("background");
                      setImageData(undefined);
                    }}
                    className="text-white btn bg-custom-500 border-custom-500 hover:text-white hover:bg-custom-600 hover:border-custom-600 focus:text-white focus:bg-custom-600 focus:border-custom-600 focus:ring focus:ring-custom-100 active:text-white active:bg-custom-600 active:border-custom-600 active:ring active:ring-custom-100 dark:ring-custom-400/20"
                  >
                    Change
                  </button>
                </div>
              </div>
            ) : (
              <button
                onClick={() => {
                  toggleImage();
                  setIndexBack("background");
                  setImageData(undefined);
                }}
                className="text-white btn bg-custom-500 border-custom-500 hover:text-white hover:bg-custom-600 hover:border-custom-600 focus:text-white focus:bg-custom-600 focus:border-custom-600 focus:ring focus:ring-custom-100 active:text-white active:bg-custom-600 active:border-custom-600 active:ring active:ring-custom-100 dark:ring-custom-400/20"
              >
                Add MobileBackground
              </button>
            )}
          </div>
        </div>
        <div className="grid grid-cols-1 gap-4 xl:grid-cols-12">
          {custom && (
            <div className="mb-4 xl:col-span-6">
              <label className="inline-block mb-2 text-base font-medium">
                Custom Code
              </label>
              <ReactSelect
                versionData={
                  versionData
                    ? {
                      label: versionData?.custom_code,
                      value: versionData?.custom_code,
                    }
                    : null
                }
                options={custom}
                isSearchable={true}
                isMulti={false}
                placeholder={"Please select custom code"}
                contentType={saticStyle}
                handleContentChange={handleStyleData}
                name={"style"}
                id={"style-type2"}
              />
            </div>
          )}
        </div>
        {/* Header Text */}
        <div className="grid grid-cols-1 gap-4 xl:grid-cols-12">
          {saticStyle?.value === "indices" && (
            <div className="mb-4 xl:col-span-6">
              <label className="inline-block mb-2 text-base font-medium">
                Header Text
              </label>
              <ReactSelect
                versionData={
                  versionData
                    ? {
                      label: versionData?.header_text,
                      value: versionData?.header_text,
                    }
                    : null
                }
                options={headerOption}
                isSearchable={true}
                isMulti={false}
                placeholder={"Please select header"}
                contentType={headerCode}
                handleContentChange={handleHeaderChange}
                name={"header_text"}
                id={"header_text2"}
              />
            </div>
          )}
        </div>

        {/* Save Button */}
        <div className="flex justify-end gap-2 mt-4">
          <Button
            isLoading={isLoading}
            handleSave={handleSave}
            pageId={pageId}
            id={segmentId}
          />

          <button
            className="text-red-500 bg-white btn hover:text-red-500 hover:bg-red-100 focus:text-red-500 focus:bg-red-100 active:text-red-500 active:bg-red-100 dark:bg-zink-600 dark:hover:bg-red-500/10 dark:focus:bg-red-500/10 dark:active:bg-red-500/10"
            onClick={() => handleDelete(segmentId, data?.segment_type)}
          >
            Delete
          </button>
        </div>
      </div>
      <Drawer
        show={showImage}
        onHide={toggleImage}
        id="drawerEnd"
        drawer-end="true"
        className="fixed inset-y-0 flex flex-col w-1/2 transition-transform duration-300 ease-in-out transform bg-white shadow ltr:right-0 rtl:left-0 z-drawer dark:bg-zink-600"
      >
        <Drawer.Header
          className="flex items-center justify-between p-4 border-b card-body border-slate-200 dark:border-zink-500"
          closeButtonClass="lucide lucide-x size-4 transition-all duration-200 ease-linear text-slate-500 hover:text-slate-700 dark:text-zink-200 dark:hover:text-zink-50"
        >
          <Drawer.Title className="text-15">{"Select Image"}</Drawer.Title>
          <X className="transition-all duration-200 ease-linear size-4 text-slate-500 hover:text-slate-700 dark:text-zink-200 dark:hover:text-zink-50"></X>
        </Drawer.Header>
        <Drawer.Body className="h-full p-4 overflow-y-auto">
          <ImageView
            showImage={showImage}
            setEventData={setImageData}
            togleImage={toggleImage}
          />
        </Drawer.Body>
      </Drawer>
    </>
  );
};

export default CodeSegments;
